// Вынесено из RealtimeProvider.tsx в отдельный файл, чтобы логику группировки/дедупликации
// можно было протестировать напрямую, без монтирования React-дерева и сокета.
import { notifyProblem } from '../lib/notify.ts';

/**
 * Складские проблемы (оверсейл, несопоставленный заказ) группируются в ОДИН тост на тип,
 * а не по одному на объект — иначе пачка заказов после реимпорта заваливает экран
 * десятками одинаковых карточек (см. задание «исправить sidebar и уведомления» от 21.09.2026).
 *
 * Дедупликация — по стабильному ключу «тип+id+содержимое»: то же самое событие для того же
 * объекта, пришедшее повторно (двойная доставка сокета, переподключение), не пересоздаёт
 * тост и не обновляет счётчик. Если содержимое для уже известного id изменилось —
 * обновляем именно эту запись группы, но заголовок группы не «мигает» как новый.
 *
 * Состояние — в памяти вкладки (useRef у вызывающего), не на сервере: после перезагрузки
 * страницы список «уже показанных» объектов начинается заново. Это осознанное ограничение
 * (см. отчёт) — серверное хранение «просмотрено/непросмотрено» по пользователю в этот заход
 * не входило.
 */
export class ProblemGroup {
  private seen = new Map<string, string>(); // objectId -> contentKey
  private toastId: string;
  private titleOf: (n: number) => string;

  constructor(toastId: string, titleOf: (n: number) => string) {
    this.toastId = toastId;
    this.titleOf = titleOf;
  }

  /** true, если это действительно новое/изменившееся событие (стоит перерисовать тост) */
  offer(objectId: string, contentKey: string): boolean {
    if (this.seen.get(objectId) === contentKey) return false;
    this.seen.set(objectId, contentKey);
    return true;
  }

  get count(): number {
    return this.seen.size;
  }

  render(buildMessage: () => string) {
    notifyProblem(this.toastId, this.titleOf(this.seen.size), buildMessage());
  }
}
